import React, { useEffect, useState } from "react";
import { Label } from "reactstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from "react-toastify";
import { isMobile } from "react-device-detect";

export default function SocialMediaPopover(props) {

    const [urlText, setUrlText] = useState('');
    const [mobileUrlText,setMobileUrlText] = useState ('');



    useEffect(() => {
        const url = `https://web.whatsapp.com/send?text= Hey,%0A I want to invite you to join Bidd, a platform that offers alternate investment products like bonds and MLDs. I think their products are perfect for you to diversify your portfolio and beat inflation.%0A%0A They also have a good track record with over 1,250 crores in AUM (assets under management), zero defaults to date, and more than 1 lakh retail investors.%0A%0A Sign up using my referral invite below: %0A ${process.env.REACT_APP_URL_ENDPOINTS}/login/?ref_code=${props.referralsDetail}%26utm_source=whatsapp%26utm_medium=dashboard`
        const mobileurl = `whatsapp://send?text=Hey,%0A I want to invite you to join Bidd, a platform that offers alternate investment products like bonds and MLDs. I think their products are perfect for you to diversify your portfolio and beat inflation.%0A%0A They also have a good track record with over 1,250 crores in AUM (assets under management), zero defaults to date, and more than 1 lakh retail investors.%0A%0A Sign up using my referral invite below:%0A ${process.env.REACT_APP_URL_ENDPOINTS}/login/?ref_code=${props.referralsDetail}%26utm_source=whatsapp%26utm_medium=dashboard`
        setUrlText(url)
        setMobileUrlText(mobileurl)
    }, [props.referralsDetail])



    return props.popoverOpen && <div className='ref-popup'>
        {/* <div className="triangle-up" /> */}
        <div className='ref-div popup-label'>
            <Label>
                {!props.isNewJourney ? props.referralsDetail : "Referral Code"}
                {/* <span onClick={() => {navigator.clipboard.writeText(process.env.REACT_APP_API_URL + '/login?refCode=' + props.referralsDetail); toast.success("Coppied successfully")}}style={{ right: "5px", top: "-3.5px", fontSize: "25px" }} class="mdi mdi-checkbox-multiple-blank-outline position-absolute"></span> */}
            </Label>
            <i onClick={() => { navigator.clipboard.writeText(process.env.REACT_APP_URL_ENDPOINTS +
                '/login/?ref_code=' + props.referralsDetail); 
                toast.success("Copied successfully") }} className="mdi mdi-content-copy" />
        </div>
        <div className="social-main">
            <div className="rounded-div">
                {!isMobile ? <a href={urlText} target="_blank"><button className="whatsapp-btn">
                    <img src={process.env.REACT_APP_IMAGES_PATH + "whatsapp.webp"} />
                    &nbsp; Invite Via WhatsApp</button></a> :
                    <a href={mobileUrlText} target="_blank"><button className="whatsapp-btn">
                    <img src={process.env.REACT_APP_IMAGES_PATH + "whatsapp.webp"} />
                    &nbsp; Invite Via WhatsApp</button></a>}
            </div>
            {/* <div className="rounded-div">
                <a href={fbText} target="_blank">
                    <img src={insta} />
                </a>
            </div>
            <div className="rounded-div">
                <a href={twitText} target="_blank">
                    <img src={twit} />
                </a>
            </div> */}
            {/* <div className="rounded-div">
                <a href={urlText} target="_blank">
                    <img src={whatsapp} />
                </a>
            </div> */}
        </div>
    </div>
    {/* <Popover
          placement="bottam"
          isOpen={popoverOpen}
          target="popoverBtn"
          toggle={togglePopover}
          className='ref-popup'
        >
          <PopoverBody style={{padding:"2rem"}}>
          <a href={urlText} target="_blank">
            <img src={whatsapp}/>
          </a>
          </PopoverBody>
        </Popover> */}
}
